import clsx from 'clsx'
import { LoadingTable } from 'components/core-v2'

import { SunburstChartLoading } from '../sunburst-chart'
import classes from './index.module.scss'
import { COLUMN_DEFS, DEFAULT_COLUMN_DEFS } from './table-options'

interface Props {
  rowCount?: number
}
export const AmountSunburstWithTableLoading = ({ rowCount = 10 }: Props) => (
  <div className={clsx('center')}>
    <div className={classes.chartWrapper}>
      <SunburstChartLoading />
    </div>
    <LoadingTable
      agGridProps={{
        columnDefs: COLUMN_DEFS(),
        defaultColDef: DEFAULT_COLUMN_DEFS,
        headerHeight: 60,
        rowHeight: 44
      }}
      className={classes.tableWrapper}
      rowCount={rowCount}
    />
  </div>
)
